import { ACCESS_TOKEN_EXPIRATION_IN_MINUTES } from "@auth/constants/auth.constants";

export const HUB_NAME = 'signalHub';
export const HUB_LISTENER_NAME = 'communicationSignal';
export const USER_DEACTIVATED_METHOD_NAME = 'UserIsDeactivated';

const RECONNECT_STEP = 5000;
const RECONNECTION_ATTEMPTS = ACCESS_TOKEN_EXPIRATION_IN_MINUTES * 60 * 1000 / RECONNECT_STEP;

export const RECONNECTION_TIME_INTERVALS = new Array<number>(RECONNECTION_ATTEMPTS).fill(RECONNECT_STEP);